import { render, staticRenderFns } from "./FavoritePlansCollapse.vue?vue&type=template&id=dde38750&scoped=true"
import script from "./FavoritePlansCollapse.vue?vue&type=script&lang=js"
export * from "./FavoritePlansCollapse.vue?vue&type=script&lang=js"
import style0 from "./FavoritePlansCollapse.vue?vue&type=style&index=0&id=dde38750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde38750",
  null
  
)

export default component.exports